import React from 'react'
import Modal from '../modal'
import { SvgCancel } from '../svg'

const ErrorModal = ({showError, toggle, showCancelButton}) => {
    return (
        <Modal
            show={showError}
            onClose={toggle}
            icon={<SvgCancel />}
            onClick={() => toggle(false)}
            confirmButtonText={gettext('Close')}
            showCancelButton={showCancelButton}
        >
            <p><strong>{gettext('Something went wrong while processing this request. If this error persists, please contact support for assistance.')}</strong></p>
        </Modal>
    )
}

ErrorModal.defaultProps = {
    showCancelButton: false
}

export default ErrorModal